import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=af0aea3a&scoped=true&"
import script from "./FileForm.vue?vue&type=script&lang=js&"
export * from "./FileForm.vue?vue&type=script&lang=js&"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=af0aea3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0aea3a",
  null
  
)

export default component.exports